import { useEffect, useRef, useState } from 'react';

import { Box, Button } from '@bcp-nextgen-dx-component-factory/design-system';
import { AppHelper, UIHelper } from '@helpers';
import { useTranslation } from '@hooks';
import { useSearchParamsStore } from '@store';

import { Footer } from '../footer';
import { Close } from '../icons';

export const ScrollableContainerWithFooter = ({ children }: { children: React.ReactNode }) => {
	const { t } = useTranslation();
	const state = useSearchParamsStore((store) => store.state);
	const [hasScrolled, setHasScrolled] = useState(false);
	const divRef = useRef<HTMLDivElement>(null);

	// show Exit link (or CloseIcon on mobile) if Url value is configured
	const exitUrl = t('components.banner.exit.url', undefined, undefined, true);
	const exit = { visible: Boolean(exitUrl), url: exitUrl };

	const handleScroll = () => {
		if (divRef.current) {
			if (divRef.current.scrollTop > 1) {
				setHasScrolled(true);
			} else {
				setHasScrolled(false);
			}
		}
	};

	const handleCloseClick = () => {
		AppHelper.exit(exit.url, 'cancelled', state);
	};

	useEffect(() => {
		const divElement = divRef.current;
		if (divElement) {
			divElement.addEventListener('scroll', handleScroll);

			return () => {
				divElement.removeEventListener('scroll', handleScroll);
			};
		}
	}, []);

	return (
		<Box styles={{ flexDirection: 'column', position: 'relative', height: '100vh' }}>
			<Box
				styles={{
					padding: UIHelper.rem(40),
					flexDirection: 'column',
					alignItems: 'end',
					minHeight: UIHelper.rem(120),
					transition: 'box-shadow 0.3s ease',
					boxShadow: hasScrolled ? '0px 8px 24px 0px #2E36411A' : 'none',
				}}
			>
				{exit.visible && (
					<Button variant="secondary" startContent={Close} onPress={handleCloseClick}>
						{t('general.exit')}
					</Button>
				)}
			</Box>
			<div
				ref={divRef}
				style={{ display: 'flex', flexDirection: 'row', overflowY: 'auto', flex: 1, alignItems: 'start' }}
			>
				{children}
			</div>

			<Footer />
		</Box>
	);
};
